import React from 'react';
import PageLayout from "../components/page-layout";
import NewUserFrom from "../components/new-user-form";
import Grid from "@material-ui/core/Grid";

export default function CreateUser() {

    return (
        <PageLayout pageTitle="ساخت کاربر">
            <Grid container justifyContent="center">
                <Grid item xs={10} sm={8} md={6}>
                <NewUserFrom/>
                </Grid>
            </Grid>
        </PageLayout>
    );
}

